import React from 'react';

import { InputBase } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import SearchIcon from '@material-ui/icons/Search';

import useDebouncedInputChange from '@/core/users/UserInvite/useDebouncedInputChange';

type Props = {
  email: string;
  onEmailChange: (email: string) => void;
}
export function UserListFilters ({ email, onEmailChange }: Props) {
  const [value, debouncedOnChange] = useDebouncedInputChange((e) => onEmailChange(e.target.value), email);

  return (
    <div className="flex border border-gray-300 rounded">
      <SearchIcon className="w-10 h-10 p-2 mx-6 my-3 text-gray-900 bg-gray-100 rounded-full" />
      <InputBase
        placeholder="Search by email"
        className="flex-grow text-sm text-gray-900"
        value={value}
        onChange={debouncedOnChange}
      />
      {email.trim() && (
        <button onClick={() => onEmailChange('')}>
          <CloseIcon className="w-5 h-5 m-auto mx-3"/>
        </button>
      )}
    </div>
  );
}
